import axios from 'axios';

export type Fields = {
  juridiction: string;
  ville?: string | null;
  file: File | undefined;
  numero_affaire: string; // eslint-disable-line camelcase
  date_dec: string; // eslint-disable-line camelcase
};

export const uploadDecision = (fields: Fields) => {
  const data = new FormData();
  (Object.keys(fields) as Array<keyof typeof fields>).forEach(key => {
    const value = fields[key];
    if (value) {
      data.append(key, value);
    }
  });
  axios.post('/send_decision', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
